// Article Record Class

import * as Utils from "@/utils/utils";
import store from "@/store/store";

export default class ArtRec {

	constructor(dat) {
		const src			= dat || {};

		this.rid		= src.rid			|| 0;
		this.itemId		= src.itemId		|| "a123";
		this.live		= src.live			|| "";
		this.stage		= src.stage			|| "";
		this.merit		= src.merit			|| "";
		this.title		= src.title			|| "";
		this.credit		= src.credit		|| "";
		this.pixId		= src.pixId			|| "";
		this.catId		= src.catId			|| "";
		this.summTxt	= src.summTxt		|| "";
		this.mainTxt	= src.mainTxt		|| "";
		this.logId		= src.logId			|| "";
		this.remAddr	= src.remAddr		|| "";
		this.browser	= src.browser		|| "";
		this.descr		= src.descr			|| "";
		this.notes		= src.notes			|| "";
		this.catItemId	= src.catItemId		|| "";
		this.catTitle	= src.catTitle		|| "";
		this.imgName	= src.imgName		|| "";
		this.thmName	= src.thmName		|| "";
		this.dir		= src.dir			|| "";
		this.dateCre	= src.dateCre		|| "";
		this.dateMod	= src.dateMod		|| "";

		this.fullTxt	= src.fullTxt		|| "";
		
		// Format visual date
		this.dateVis = Utils.calcVisDate(this.dateCre);

		// Main Pix Index
		this.mainIdx = 0;
		
		const state = store.getters["app/state"];
		let newCat = state.cats[0]; 
		for (let cat of state.cats) if (cat.itemId == this.catId) newCat = cat;
		this.cat = newCat;

	}


}
